export default "__VITE_ASSET__X5iHRFjb__"